var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvChargingOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 82 75",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-880,-719)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,197.157,-1135.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0391899,0,0,0.0219986,634.82,989.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ev"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.0993,0,0,19.0993,-13105.1,-7226.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.422,400.002L716.797,399.963C711.954,399.991 710.497,401.125 710.552,405.72L710.487,444.743C710.469,455.492 712.898,454.496 721.94,454.511",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "5.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer4",
    transform: "matrix(19.0993,0,0,19.0993,-13063.5,-7991.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.679,488.626L720.682,504.601L725.877,511.403L732.076,511.403C732.828,507.125 734.846,504.113 739.649,503.888C743.354,504.226 746.067,506.383 747.222,511.403L773.93,511.403C773.951,505.823 779.004,504.096 781.819,504.173C784.931,504.259 788.138,508.051 789.21,511.143C793.858,511.254 798.393,509.761 800.284,509.114C802.926,507.981 806.033,505.188 806.116,500.431C806.116,491.329 799.557,488.856 792.381,488.346C777.92,487.318 720.679,488.626 720.679,488.626Z",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "5.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.5126,0,0,13.8916,-9493.37,-4757.14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.495,
    cy: 470.456,
    rx: 9.966,
    ry: 10.332,
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "6.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.5126,0,0,13.8916,-10292.7,-4757.14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.495,
    cy: 470.456,
    rx: 9.966,
    ry: 10.332,
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "6.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.7924,-0.0168424,0.0155049,15.4589,-11279.4,-5606.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.048,449.671L713.093,450.346C713.093,450.346 713.014,443.698 713.273,438.38C713.639,430.887 719.724,428.576 724.668,428.491C729.147,428.414 736.614,428.162 745.213,428.209L746.048,449.671Z",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "6.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.671,0,0,20.4101,-13550.6,-7815.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.068,448.213L752.785,448.232L752.16,431.966C752.16,431.966 761.761,431.889 770.849,431.931L790.068,448.213Z",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "4.85px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.87236,0.00265985,0.00284974,3.30257,203.601,-511.278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L922.626,312.408",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "36.21px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.89828,0.00201136,0.00215496,3.30258,182.208,-731.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L921.412,312.451",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "36.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.10755,0,0,2.33903,7.33108,-179.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.332,256.301C664.813,184.261 728.853,164.091 831.748,162.735L834.236,351.489C724.41,350.755 663.839,330.095 664.332,256.301Z",
    style: {
      fill: "none",
      stroke: "rgb(0,177,92)",
      strokeWidth: "43.7px"
    }
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargingOutline);
export default __webpack_public_path__ + "static/media/evChargingOutline.d4c710fd0636b241b965efc0808fd963.svg";
export { ForwardRef as ReactComponent };